import { API_URL, SNAP_URL } from "@core/constants";
import { sanitize } from "@datassential/platform-ui-lib";

const getAuthRedirectUrl = (): string => {
    return sanitize(`${API_URL}/userAuth?returnUrl=${window.location.href}`);
};

const getSnapRedirectUrl = (): string => {
    return SNAP_URL ?? '';
};

export enum ResponseStatusAction {
    RedirectAuth,
    RedirectSnap,
    Success,
    Error,
}

export function getStatusAction(status: number): ResponseStatusAction {
    if (status === 401) {
        return ResponseStatusAction.RedirectAuth;
    }
    if (status === 403) {
        return ResponseStatusAction.RedirectSnap;
    }
    if (status >= 200 && status < 300) {
        return ResponseStatusAction.Success;
    }
    return ResponseStatusAction.Error;
}

export function handleRedirect(action: ResponseStatusAction): void {
    switch (action) {
        case ResponseStatusAction.RedirectAuth:
            window.location.href = getAuthRedirectUrl();
            break;
        case ResponseStatusAction.RedirectSnap:
            window.location.href = getSnapRedirectUrl();
            break;
        default:
            break;
    }
}

export function handleResponseStatus(
    status: number,
    onSuccess?: () => void,
    onError?: () => void
): void {
    const action = getStatusAction(status);

    switch (action) {
        case ResponseStatusAction.RedirectAuth:
        case ResponseStatusAction.RedirectSnap:
            handleRedirect(action);
            break;
        case ResponseStatusAction.Success:
            onSuccess?.();
            break;
        case ResponseStatusAction.Error:
            onError?.();
            break;
    }
}
